import React from 'react';
import './LegalPages.css';

const Contact = () => {
  return (
    <div className="legal-page">
      <section className="legal-header">
        <div className="legal-header-content">
          <h1>Contact Us</h1>
          <p className="subtitle">We're Here to Help</p>
          <p className="description">
            Have a question or need assistance? Our support team is ready to help you.
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="content-wrapper">
          <aside className="table-of-contents">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#support">Customer Support</a></li>
              <li><a href="#business">Business Inquiries</a></li>
              <li><a href="#technical">Technical Support</a></li>
            </ul>
          </aside>

          <main className="main-content">
            <section id="support" className="content-section">
              <h2>Customer Support</h2>
              <p>
                Our customer support team is available to assist you with any questions about DocuAIHub.
              </p>
              <div style={{ background: '#f8fafc', padding: '2rem', borderRadius: '12px', marginTop: '1.5rem' }}>
                <p><strong>📧 Email:</strong> <a href="mailto:help@docuaihub.com">help@docuaihub.com</a></p>
                <p><strong>📞 Phone:</strong> <a href="tel:+35777788373">+357 77788373</a></p>
                <p><strong>🕐 Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM CET</p>
                <p><strong>⏱️ Response Time:</strong> Within 24 hours</p>
              </div>
            </section>

            <section id="business" className="content-section">
              <h2>Business Inquiries</h2>
              <p>
                For partnership opportunities, enterprise solutions, or business-related questions:
              </p>
              <ul>
                <li><strong>Email:</strong> <a href="mailto:help@docuaihub.com">help@docuaihub.com</a></li>
                <li><strong>Company Website:</strong> <a href="https://www.ambglobaldigital.com" target="_blank" rel="noopener noreferrer">www.ambglobaldigital.com</a></li>
              </ul>
            </section>

            <section id="technical" className="content-section">
              <h2>Technical Support</h2>
              <p>
                Experiencing technical issues or need help with our platform?
              </p>
              <ul>
                <li><strong>Email:</strong> <a href="mailto:help@docuaihub.com">help@docuaihub.com</a></li>
                <li><strong>Include:</strong> Your account email, description of the issue, and any error messages</li>
              </ul>
              <p>
                For faster resolution, please include:
              </p>
              <ul>
                <li>Account email address</li>
                <li>Detailed description of the issue</li>
                <li>Screenshots (if applicable)</li>
                <li>Browser and device information</li>
              </ul>
            </section>

            <section className="content-section">
              <h2>Company Information</h2>
              <p><strong>AMB GLOBAL DIGITAL SOLUTIONS LTD</strong></p>
              <p>1 Maiou 3, 2610 Agios Epifanios Oreinis</p>
              <p>Cyprus</p>
              <p>Registration: CY12345678</p>
            </section>
          </main>
        </div>
      </section>
    </div>
  );
};

export default Contact;
